// Iconos SVG inline (sin librerias). Estilo heroicons-outline, 20px,
// stroke=currentColor para heredar el color del contenedor.

const svg = (d: string, extra = ""): string =>
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" class="h-5 w-5 ${extra}">${d}</svg>`;

export const iconoLapiz = svg(
  `<path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"/>`,
);
export const iconoMas = svg(`<path d="M12 5v14M5 12h14"/>`);
export const iconoTacho = svg(
  `<path d="M3 6h18M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2m2 0v14a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6"/><path d="M10 11v6M14 11v6"/>`,
);
export const iconoImpresora = svg(
  `<path d="M6 9V3h12v6M6 18H4a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-2"/><path d="M6 14h12v7H6z"/>`,
);
export const iconoBuscar = svg(`<circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/>`);
export const iconoChevron = svg(`<path d="m6 9 6 6 6-6"/>`, "transition-transform");
export const iconoRevertir = svg(`<path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/>`);
export const iconoMenu = svg(`<path d="M4 6h16M4 12h16M4 18h16"/>`);
export const iconoAyuda = svg(
  `<circle cx="12" cy="12" r="9"/><path d="M9.5 9a2.5 2.5 0 1 1 3.8 2.1c-.8.5-1.3 1-1.3 1.9"/><circle cx="12" cy="16.8" r=".5"/>`,
);
export const iconoCerrar = svg(`<path d="M6 6l12 12M18 6L6 18"/>`);
export const iconoFlechaDer = svg(`<path d="m9 6 6 6-6 6"/>`);
export const iconoLlave = svg(
  `<circle cx="7.5" cy="15.5" r="4"/><path d="m10.5 12.5 8-8"/><path d="m16 7 2 2"/><path d="m19 4 2 2"/>`,
);
export const iconoCampana = svg(
  `<path d="M18 8a6 6 0 1 0-12 0c0 6-2 7-2 7h16s-2-1-2-7"/><path d="M10.5 20a2 2 0 0 0 3 0"/>`,
);
export const iconoTilde = svg(`<path d="m5 13 4 4L19 7"/>`);
export const iconoLuna = svg(`<path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8Z"/>`);
export const iconoSol = svg(
  `<circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/>`,
);
export const iconoUsuario = svg(`<circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/>`);

/**
 * El logo de la confiteria, el mismo que el icono de la app instalada.
 *
 * Es una funcion y no una constante para que la marca salga IDENTICA en los
 * tres lugares donde aparece (barra, menu movil y login) y alcance con tocar
 * un solo archivo si cambia. El PNG de 64 pesa 11 KB: el de 192 serian 82 KB
 * de datos del celular para mostrarlo a 28 px.
 */
export const logoApp = (clase = "h-7 w-7"): string =>
  `<img src="/icono-64.png" alt="" width="64" height="64" class="${clase} rounded-lg object-contain" />`;

// Icono por ruta del nav (para el menu movil).
const RUTA_ICONO: Record<string, string> = {
  "#/pedido": `<path d="M6 3h12v18l-2.5-1.5L13 21l-2.5-1.5L8 21l-2-1.5L4 21V3h2Z"/><path d="M9 8h6M9 12h6"/>`,
  "#/produccion": `<rect x="3" y="4" width="18" height="16" rx="2"/><path d="M3 9h18"/><path d="M6.5 6.5h.01"/>`,
  "#/cuentas": `<rect x="3" y="6" width="18" height="12" rx="2"/><circle cx="12" cy="12" r="2.5"/><path d="M6 9v6M18 9v6"/>`,
  "#/listas": `<path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01"/>`,
  "#/clientes": `<circle cx="9" cy="8" r="3"/><path d="M4 20a5 5 0 0 1 10 0"/><path d="M17 6a3 3 0 0 1 0 6"/><path d="M15.5 20a5 5 0 0 1 5-5"/>`,
  "#/productos": `<path d="M21 8l-9-5-9 5 9 5 9-5Z"/><path d="M3 8v8l9 5 9-5V8"/><path d="M12 13v8"/>`,
  "#/categorias": `<path d="M20.5 11.5 12 3H4v8l8.5 8.5a2 2 0 0 0 2.83 0l5.17-5.17a2 2 0 0 0 0-2.83Z"/><circle cx="7.5" cy="7.5" r="1.2"/>`,
  "#/subas": `<path d="M3 17l6-6 4 4 8-8"/><path d="M15 7h6v6"/>`,
  "#/informes": `<path d="M3 3v18h18"/><rect x="7" y="12" width="3" height="6"/><rect x="12" y="8" width="3" height="10"/><rect x="17" y="5" width="3" height="13"/>`,
  "#/usuarios": `<circle cx="9" cy="8" r="3"/><path d="M4 20a5 5 0 0 1 10 0"/><path d="M17 6a3 3 0 0 1 0 6"/><path d="M15.5 20a5 5 0 0 1 5-5"/>`,
  "#/auditoria": `<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 3"/>`,
  // Portal del local y bandeja de pedidos web
  "#/pedidos-web": `<rect x="3" y="4" width="18" height="16" rx="2"/><path d="M8 10h8M8 14h5"/><circle cx="18" cy="6" r="3" fill="currentColor" stroke="none"/>`,
  "#/pedir": `<path d="M6 6h15l-1.5 9h-12z"/><circle cx="9" cy="20" r="1.5"/><circle cx="18" cy="20" r="1.5"/><path d="M6 6 5 3H2"/>`,
  "#/mispedidos": `<path d="M6 3h12v18l-2.5-1.5L13 21l-2.5-1.5L8 21l-2-1.5L4 21V3h2Z"/><path d="M9 8h6M9 12h6"/>`,
  "#/micuenta": `<rect x="3" y="6" width="18" height="12" rx="2"/><circle cx="12" cy="12" r="2.5"/><path d="M6 9v6M18 9v6"/>`,
};
export function iconoRuta(hash: string): string {
  return svg(RUTA_ICONO[hash] ?? `<circle cx="12" cy="12" r="8"/>`);
}

// Icono por area/categoria de produccion (fallback: pan generico).
const PORNOMBRE: Record<string, string> = {
  Bizcochos: `<path d="M12 3c3 2 4 5 4 8a4 4 0 0 1-8 0c0-3 1-6 4-8Z"/>`,
  Confiteria: `<path d="M4 20h16M6 20v-4a6 6 0 0 1 12 0v4"/><path d="M12 6V3"/>`,
  Galleta: `<circle cx="12" cy="12" r="8"/><circle cx="9" cy="10" r="1"/><circle cx="14" cy="9" r="1"/><circle cx="13" cy="14" r="1"/>`,
  Medialunas: `<path d="M16 4a8 8 0 1 0 4 12A6 6 0 0 1 16 4Z"/>`,
  Sandwicheria: `<path d="M3 8h18l-2 3H5Z"/><path d="M5 11h14v2H5z"/><path d="M4 15h16l-2 3H6Z"/>`,
  Roscas: `<circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="3"/>`,
  Rotiseria: `<path d="M12 3v3M8 6h8M6 9h12l-1 9a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2Z"/>`,
};

export function iconoCategoria(nombre: string): string {
  const d = PORNOMBRE[nombre] ?? `<path d="M4 11a4 4 0 0 1 4-4h8a4 4 0 0 1 0 8H8a4 4 0 0 1-4-4Z"/>`;
  return svg(d);
}
